const {h, render, Component} = require('preact');

class ClaimView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    let claim = this.props.claim;
    if(claim)
    {
    return (
        <td className="claim-data-cell ch-bdr-prim ca-bdr-prim" width="50%" key={claim.claimId} dealId={claim.claimId} onClick={this.props.claimDetails} data-bhw="web2018_claim_summary">
          <table className="cell-table">
            <tr className="cell-row">
              <td className="image cell-column">
                <img src={claim.imageUrl} alt="Deal Image"/>
              </td>
              <td className="claim-info cell-column">
                <p className="b title"> {claim.merchantName}</p>
                <p className="description"> {claim.title} </p>
                <p>
                  <span className="claim-date-info">{claim.expiresIn}</span>
                </p>
              </td>
            </tr>
          </table>
        </td>
    )
  }
  return(<td></td>)
  }
}

module.exports = ClaimView
